<template>
  <div
    :class="{
      'inficator-date': true,
      'inficator-date_disabled': disabled
    }"
  >
    <span class="inficator-date__title">{{ name }}</span>
    <div class="inficator-date__content">
      <div class="inficator-date__text" v-if="!calendar">
        <span>{{ date }}</span>
      </div>
      <Calendar
        v-if="calendar"
        date-format="dd.mm.yy"
        show-icon
        :show-time="showTime"
        hourFormat="24"
        :model-value="date"
        @date-select="$emit('changeDate', $event)"
        style="height: 100%; width: 249px;"
        :disabled="disabled"
      >
        <template #footer="slotProps">
          {{ slotProps.data }}
          <div class="calendar-clear">
            <button
              class="p-button"
              @click="$emit('changeDate', null)"
            >
              Очистить
            </button>
          </div>
        </template>
      </Calendar>
    </div>
    <div
      class="inficator-date__icons"
      v-if="!calendar && mark && !disabled"
      @click="$emit('clickIcon')"
    >
      <mark-icon/>
    </div>
  </div>
</template>

<script>
import MarkIcon from '@/components/icons/MarkIcon.vue'

import Calendar from 'primevue/calendar'

export default {
  name: 'IndicatorDate',
  components: {
    MarkIcon,
    Calendar
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    mark: {
      type: Boolean,
      default: false
    },
    calendar: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showTime: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.inficator-date {
  position: relative;
  display: flex;
  justify-content: space-between;
  min-width: 225px;
  background: #FFFFFF;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
  border-radius: 4px;

  &_disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  &__title {
    position: absolute;
    left: 12px;
    top: -8px;
    z-index: 2;
    background-color: #fff;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #1BA6DA;
  }

  &__content {
    flex: 1;
  }

  &__text {
    width: 100%;
    height: 100%;
    padding: 10px 0 10px 8px;
    text-align: start;
    vertical-align: middle;
    line-height: 22px;
  }

  &__icons {
    @include flex-center;
    width: 42px;
    height: 42px;
    border-left: 1px solid #BCBCBC;
    cursor: pointer;
  }
}

:deep(.p-button) {
  background: #1ba6da;
  border: 1px solid #1ba6da;
  }
:deep(.p-button:enabled:hover) {
  background: #1ba6da;
  color: #ffffff;
  border-color: #1ba6da;
}

:deep(.p-calendar .p-inputtext) {
  height: 100%;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 137.5% */
  letter-spacing: -0.32px;
}

.calendar-clear {
  width: 100%;
  text-align: center;
}

</style>
